import { ADICIONAR_PASSAGEIROS_VOLTA } from '../types'

export default function adicionarPassageirosVolta (passageiros) {
  return {
    type: ADICIONAR_PASSAGEIROS_VOLTA,
    payload: passageiros
  }
}
